import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSucessResponse } from "../../utils/API/responseMiddleware";

const reportsAPI = createApi({
    reducerPath: 'reportsAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        getCandidateListReportByChannelandSource: builder.mutation({
            query: (details) => ({
                url: '/Reports/GetCandidateListReportByChannelandSource',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getCandidateListReportByJob: builder.mutation({
            query: (details) => ({
                url: '/Reports/GetCandidateListReportByJob',
                method: 'POST',
            body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        exportCandidateListReportByChannelandSource: builder.mutation({
            query: (details) => ({
                url: '/Reports/ExportCandidateListReportByChannelandSource',
                method: 'POST',
                body: transformRequest(details),
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        exportCandidateListReportByJob: builder.mutation({
            query: (details) => ({
                url: '/Reports/ExportCandidateListReportByJob',
                method: 'POST',
                body: transformRequest(details),
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        exportCandidateActivityLogReport: builder.mutation({
            query: (details) => ({
                url: '/Reports/ExportCandidateActivityLogReport',
                method: 'POST',
                body: transformRequest(details),
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),


    })
})

export const {
    useGetCandidateListReportByChannelandSourceMutation,
    useGetCandidateListReportByJobMutation,
    useExportCandidateListReportByChannelandSourceMutation,
    useExportCandidateListReportByJobMutation,
    useExportCandidateActivityLogReportMutation,
} = reportsAPI;
export default reportsAPI;